import React, { useEffect } from "react";
import { useAuthStore } from "@/store/authStore.ts";
import { useNavigate } from "react-router-dom";
import { PAGE_ROUTES } from "@/constants";

const useRedirectByRoles = () => {
  const isAuth = useAuthStore((state) => state.isAuth);
  const userRole = useAuthStore((state) => state.role);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuth) {
      switch (userRole) {
        case "administrator": {
          navigate(PAGE_ROUTES.BUDGET);
          break;
        }
        case "contractor": {
          navigate(PAGE_ROUTES.PROJECTS);
          break;
        }
        case "oem": {
          navigate(PAGE_ROUTES.PROJECTS);
          break;
        }
        default: {
          navigate(PAGE_ROUTES.PROJECTS);
          break;
        }
      }
    }
  }, [isAuth, userRole]);
};

export default useRedirectByRoles;
